import BaseModule from './BaseModule.js';

class Wallet extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`/back-office/wallets`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`/back-office/wallets/${id}`);
  }

  async create({ status, name, network, address, is_default, customer_id }) {
    return await this.post(`/back-office/wallets`, {
      status: status,
      name: name,
      network: network,
      address: address,
      is_default: is_default,
      customer_id: customer_id,
    });
  }

  async update({ id, status, name, network, address, is_default, customer_id }) {
    return await this.patch(`/back-office/wallets/${id}`, {
      status: status,
      name: name,
      network: network,
      address: address,
      is_default: is_default,
      customer_id: customer_id,
    });
  }
}

export default Wallet;
